// extracted by mini-css-extract-plugin
export var circle = "product-card-module--circle--bRumY";
export var productDetailsStyle = "product-card-module--productDetailsStyle--2N58r";
export var productHeadingStyle = "product-card-module--productHeadingStyle--ZH28N";
export var productPrice = "product-card-module--productPrice--HRUSo";
export var productVendorStyle = "product-card-module--productVendorStyle--dbtlX";